import { render, staticRenderFns } from "./setting-organization-branded-link-shortener-settings.vue?vue&type=template&id=3ea00108&scoped=true&"
import script from "./setting-organization-branded-link-shortener-settings.vue?vue&type=script&lang=js&"
export * from "./setting-organization-branded-link-shortener-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea00108",
  null
  
)

export default component.exports